import {Skeleton} from "@mui/material";
import {shallowEqual, useSelector} from "react-redux";
import {sharedSelectors} from "@/redux/slices/admin/shared";

const StudentRegistrationName = ({uid}: { uid: number }) => {
    const registrationName = useSelector(state => sharedSelectors.getRegistrationName(state), shallowEqual);

    return <>
        {!registrationName ? <Skeleton sx={{width: "5rem"}} variant="text"/> : registrationName}
    </>
}

export default StudentRegistrationName;